import { Paper, SelectChangeEvent, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";


import { useNavigate } from "react-router-dom";
import configUrls from "../../../config/configUrls";
import errorFormat from "../../../utils/errorFormat";

import { Documento, ISdocumento } from "../../../types/processo/Documento";
import { TipoDocumento } from "../../../types/tipoDocumento/TipoDocumento";
import { ProcessoGerarDocumentoForm } from "./ProcessoGerarDocumentoForm";
import { useCreateDocumento1Mutation } from "./documentoApiSlice";
import { ISsetor, Setor } from "../../../types/setor/Setor";
import { ISusuario, Usuario } from "../../../types/usuario/Usuario";
import { RootState } from "../../../app/store";
import { useDispatch, useSelector } from "react-redux";
import { addDocumentoProcessoSelecioadoSlice } from "../../iniciarProcesso/processoSelecionadoSlice";


export const ProcessoGerarDocumentoCreate = () => {

    const [documento, setDocumento] = useState<Documento>(ISdocumento);
    const [setorSelecionadoTemp, setSetorSelecionadoTemp] = useState<Setor>(ISsetor);
    const [interessadoSelecionadoTemp, setInteressadoSelecionadoTemp] = useState<Usuario>(ISusuario);

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createDocumento, status] = useCreateDocumento1Mutation();
    const navigate = useNavigate();


    //ler do RTK o processo selecionado    
    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!processoSelecionado) {
            // navigate(configUrls.PROCESSO_LIST_RT);
            window.location.href = configUrls.PROCESSO_LIST_RT
        } else {
            setDocumento((prev) => ({
                ...prev,
                processoId: processoSelecionado.id
            }));
        }
    }, []);


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setDocumento((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };


    const handleTipoDocumentoChange = (tipoDoc: TipoDocumento) => {
        setDocumento((prev) => ({
            ...prev,
            tipoDocumento: tipoDoc || null
        }));
    };

    const handletxtSetorChange = (setor: Setor) => {
        setSetorSelecionadoTemp(setor)
    };

    const handleAdicionarSetor = () => {
        if (setorSelecionadoTemp && setorSelecionadoTemp.id) {

            if (documento.setores && documento.setores.some((setor) => setor.id === setorSelecionadoTemp.id)) {
                enqueueSnackbar("Este setor já está adicionado ao documento!", { variant: "error" });
                return;
            }
            setDocumento((prevDocumento) => ({
                ...prevDocumento,
                setores: prevDocumento.setores
                    ? [...prevDocumento.setores, setorSelecionadoTemp]  // Se 'setores' já existe, adiciona o setor ao array
                    : [setorSelecionadoTemp]  // Se 'setores' é null, cria um novo array com o setor
            }));
            setSetorSelecionadoTemp(ISsetor);
        }
    }

    const handleExcluirSetor = (setor: Setor) => {
        if (documento.setores) {

            //crio um novo array de setor sem o setor a ser excluito
            const novosSetores = documento.setores.filter((it) => it.id !== setor.id);

            setDocumento((prevDocumento) => ({
                // Remove o setor do array se ele existir
                ...prevDocumento,
                setores: novosSetores,
            }));
        }
    }




    const handletxtInteressadoChange = (usuario: Usuario) => {
        setInteressadoSelecionadoTemp(usuario);
    };

    const handleAdicionarInteressado = () => {
        if (interessadoSelecionadoTemp && interessadoSelecionadoTemp.id) {

            if (documento.interessados && documento.interessados.some((it) => it.id === interessadoSelecionadoTemp.id)) {
                enqueueSnackbar("Esta pessoa já está adicionada ao documento!", { variant: "error" });
                return;
            }
            setDocumento((prevDocumento) => ({
                ...prevDocumento,
                interessados: prevDocumento.interessados
                    ? [...prevDocumento.interessados, interessadoSelecionadoTemp]  // Se 'setores' já existe, adiciona o setor ao array
                    : [interessadoSelecionadoTemp]  // Se 'setores' é null, cria um novo array com o setor
            }));
            setInteressadoSelecionadoTemp(ISusuario);
        }
    }

    const handleExcluirInteressado = (value: Usuario) => {
        if (documento.interessados) {

            //crio um novo array de sem o ser excluito
            const novosInteressados = documento.interessados.filter((it) => it.id !== value.id);

            setDocumento((prevDocumento) => ({
                // Remove o setor do array se ele existir
                ...prevDocumento,
                interessados: novosInteressados,
            }));
        }
    }





    const handleChangeNivelAcesso = (e: SelectChangeEvent) => {
        const value: string = e.target.value as string;

        if (value === "SIGILOSO" || value === "RESTRITO" || value === "PUBLICO") {
            setDocumento((prev) => ({
                ...prev,
                'nivelAcesso': value,
            }));
        } else {
            enqueueSnackbar("Selecione um nível de acesso válido!", { variant: "error" })
            setDocumento((prev) => ({ ...prev }));
            return;
        }
    };


    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {


        e.preventDefault();
        await createDocumento(documento);
    }

    useEffect(() => {

        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            dispatch(addDocumentoProcessoSelecioadoSlice(status.data));
            navigate(`${configUrls.PROCESSO_DOCUMENTO_VIEW_LK}${status.data.id}`);
            // setDocumento(ISdocumento);    
        }

    }, [status]);








    return (



        <>


            <Paper>

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Gerar Documento
                </Typography>



                <ProcessoGerarDocumentoForm
                    data={documento}
                    // isdisabled={status.isLoading}
                    //isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                    handleChangeNivelAcesso={handleChangeNivelAcesso}
                    handletxtTipoDocumentoChange={handleTipoDocumentoChange}
                    handletxtSetorChange={handletxtSetorChange}
                    setorValueTmp={setorSelecionadoTemp}
                    handleAdicionarSetor={handleAdicionarSetor}
                    handleExcluirSetor={handleExcluirSetor}

                    handletxtInteressadoChange={handletxtInteressadoChange}
                    interessadoValueTmp={interessadoSelecionadoTemp}
                    handleAdicionarInteressado={handleAdicionarInteressado}
                    handleExcluirInteressado={handleExcluirInteressado}
                />

            </Paper>










        </>







    );










};

/*
 <DocumentoTurmaForm
                    documentoTurma={documentoTurmaState}
                    isdisabled={status.isLoading}
                    isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
*/